export interface Article {
  id: string;
  slug: string;
  title: string;
  summary: string;
  content: string;
  categoryId: string;
  categoryName: string;
  imageSeq: string;
  readCount: number;
  publishedAt: string;
  tags: string[];
}

export const articles: Article[] = [
  {
    id: "1",
    slug: "xinshou-ru-men-zhi-nan",
    title: "开云平台新用户入门指南：从注册到熟练使用",
    summary: "本文为新用户详细介绍开云平台的注册流程、基本操作方法和使用技巧，帮助您快速熟悉平台各项功能。",
    content: `## 一、注册流程
开云平台的注册流程简单快捷，只需几个步骤即可完成。

首先，访问开云平台官方网站，点击页面右上角的"注册"按钮。系统将引导您进入注册页面。

在注册页面中，您需要填写以下信息：
- 用户名：建议使用字母和数字组合，长度6-16位
- 密码：需包含大小写字母和数字，长度8-20位
- 手机号码：用于接收验证码和账户安全验证
- 验证码：按页面提示输入图形验证码

填写完成后，阅读并同意《用户服务协议》和《隐私政策》，点击"立即注册"即可完成。

## 二、账户安全设置
注册成功后，建议您第一时间完善账户安全设置：
1. 绑定手机号码，开启短信验证
2. 设置安全问题和答案
3. 开启登录保护功能
4. 定期修改密码

## 三、平台功能概览
开云平台提供丰富的功能模块：
- 个人中心：管理账户信息和偏好设置
- 消息通知：接收平台重要通知和活动提醒
- 客服支持：7×24小时在线客服为您服务

## 四、常见注意事项
- 请勿将账户信息透露给他人
- 定期检查账户登录记录
- 如发现异常登录，立即联系客服`,
    categoryId: "platform-guide",
    categoryName: "平台指南",
    imageSeq: "article-guide-01",
    readCount: 12580,
    publishedAt: "2026-08-01",
    tags: ["新手指南", "注册教程", "入门指南"],
  },
  {
    id: "2",
    slug: "zhang-hu-an-quan-she-zhi",
    title: "账户安全设置完整教程：全方位保护您的账户",
    summary: "详细介绍开云平台账户安全的各项设置方法，包括密码管理、双重验证、登录保护等功能的使用教程。",
    content: `## 账户安全的重要性
在互联网时代，账户安全至关重要。开云平台始终将用户账户安全放在首位，提供多层次的安全保护机制。

## 密码安全设置
一个强密码应该具备以下特征：
- 至少包含8个字符
- 同时包含大写字母、小写字母和数字
- 避免使用生日、手机号等个人信息
- 定期更换密码，建议每90天更换一次

## 双重验证设置
开云平台支持多种双重验证方式：
1. 短信验证：登录时向绑定手机发送验证码
2. 邮箱验证：向绑定邮箱发送验证链接
3. 人脸识别：使用生物特征进行身份验证

建议您至少开启一种双重验证方式，大幅提升账户安全性。

## 登录保护功能
开启登录保护后，系统会自动检测异常登录行为：
- 异地登录提醒
- 新设备登录验证
- 多次密码错误锁定
- 可疑操作实时拦截

## 安全建议总结
- 定期检查账户安全状态
- 不要在公共设备上保存密码
- 警惕钓鱼网站和诈骗信息
- 及时更新绑定信息`,
    categoryId: "security",
    categoryName: "安全中心",
    imageSeq: "article-security-01",
    readCount: 8930,
    publishedAt: "2026-07-28",
    tags: ["账户安全", "密码设置", "双重验证"],
  },
  {
    id: "3",
    slug: "ping-tai-zui-xin-gong-neng-geng-xin",
    title: "2026年8月平台功能更新公告：全新体验升级",
    summary: "了解开云平台最新推出的功能优化和体验升级，包括界面改版、性能提升和新增服务模块。",
    content: `## 更新概述
开云平台于2026年8月进行了全面功能升级，旨在为用户提供更加流畅、便捷的使用体验。

## 界面优化
本次更新对平台界面进行了全面优化：
- 全新视觉设计，界面更加简洁美观
- 导航结构优化，功能入口更加清晰
- 响应式布局改进，移动端体验大幅提升
- 深色模式支持，护眼更舒适

## 性能提升
技术团队对平台底层架构进行了优化：
- 页面加载速度提升40%
- 操作响应时间缩短50%
- 服务器稳定性增强
- 数据传输加密升级

## 新增功能
本次更新新增了以下实用功能：
- 智能推荐系统：根据用户偏好推荐相关内容
- 消息中心升级：支持分类管理和自定义通知
- 数据看板：可视化展示个人使用数据
- 快捷操作面板：常用功能一键直达

## 后续计划
我们将在接下来的版本中继续优化用户体验，敬请期待更多实用功能上线。`,
    categoryId: "latest-news",
    categoryName: "最新动态",
    imageSeq: "article-news-01",
    readCount: 15200,
    publishedAt: "2026-08-05",
    tags: ["功能更新", "版本公告", "体验升级"],
  },
  {
    id: "4",
    slug: "chang-jian-wen-ti-jie-da",
    title: "开云平台常见问题汇总：快速解决您的疑惑",
    summary: "汇总用户在使用开云平台过程中最常遇到的问题及详细解决方案，帮助您快速找到答案。",
    content: `## 账户相关
**Q: 忘记密码怎么办？**
A: 在登录页面点击"忘记密码"，通过绑定的手机号或邮箱接收验证码后即可重置密码。

**Q: 如何修改绑定手机号？**
A: 进入个人中心 > 账户安全 > 手机绑定，按照提示完成验证后即可修改。

**Q: 账户被锁定如何解锁？**
A: 账户因多次密码错误被锁定后，等待30分钟自动解锁，或联系客服人工解锁。

## 使用相关
**Q: 平台支持哪些浏览器？**
A: 推荐使用Chrome、Firefox、Safari、Edge等主流浏览器的最新版本。

**Q: 遇到页面加载异常怎么办？**
A: 请尝试清除浏览器缓存、更换网络环境或使用其他浏览器访问。

## 服务相关
**Q: 客服响应时间是多久？**
A: 我们的客服团队7×24小时在线，平均响应时间不超过3分钟。

**Q: 如何提交意见建议？**
A: 您可以通过"联系我们"页面提交反馈，或在个人中心使用"意见反馈"功能。`,
    categoryId: "faq-help",
    categoryName: "常见问题",
    imageSeq: "article-faq-01",
    readCount: 20150,
    publishedAt: "2026-07-20",
    tags: ["常见问题", "使用帮助", "FAQ"],
  },
  {
    id: "5",
    slug: "ke-fu-fu-wu-zhi-nan",
    title: "开云平台客服服务指南：多种渠道为您服务",
    summary: "详细介绍开云平台的客服服务体系，包括在线客服、电话咨询、邮件支持等多种联系渠道。",
    content: `## 客服服务体系
开云平台建立了完善的客户服务体系，确保每一位用户的问题都能得到及时有效的解决。

## 在线客服
在线客服是我们最便捷的服务渠道：
- 服务时间：7×24小时全天候服务
- 响应速度：平均响应时间不超过3分钟
- 服务范围：账户问题、使用咨询、投诉建议等
- 入口位置：平台右下角客服图标

## 电话咨询
对于紧急问题，您可以通过电话联系我们的客服团队：
- 客服热线：400-XXX-XXXX
- 服务时间：每日9:00-21:00
- 国际用户：+86-10-XXXXXXXX

## 邮件支持
非紧急问题可通过邮件咨询：
- 客服邮箱：support@kaiyun.com
- 回复时间：工作日24小时内回复

## 自助服务
平台还提供丰富的自助服务功能：
- 帮助中心：搜索常见问题解决方案
- 智能客服：AI助手快速解答基础问题
- 社区论坛：与其他用户交流使用心得`,
    categoryId: "service-support",
    categoryName: "服务支持",
    imageSeq: "article-service-01",
    readCount: 6780,
    publishedAt: "2026-07-15",
    tags: ["客服服务", "联系渠道", "服务指南"],
  },
  {
    id: "6",
    slug: "yong-hu-ti-yan-fen-xiang",
    title: "真实用户分享：我在开云平台的三年使用体验",
    summary: "一位资深用户分享在开云平台三年的真实使用体验，从各个方面讲述平台的优点与持续改进。",
    content: `## 前言
作为一名从平台创立初期就开始使用的老用户，我想分享一下这三年来在开云平台的使用体验。

## 初识开云平台
三年前，经朋友推荐我第一次接触开云平台。当时吸引我的是平台的简洁界面和流畅的操作体验。注册过程非常顺利，不到两分钟就完成了全部步骤。

## 日常使用体验
在日常使用中，我最欣赏开云平台的以下几点：
1. 稳定性：三年来几乎没有遇到过系统崩溃或长时间维护
2. 安全性：多次收到异地登录提醒，安全保护非常到位
3. 客服服务：每次遇到问题，客服都能快速响应并解决
4. 持续更新：平台功能不断丰富，体验越来越好

## 印象深刻的服务
有一次我不小心忘记了密码，通过手机验证码几分钟就完成了重置，完全没有影响正常使用。还有一次遇到支付问题，客服在5分钟内就帮我解决了。

## 总结建议
三年的使用让我对开云平台建立了充分的信任。对于新用户，我建议：
- 认真阅读新手指南
- 完善账户安全设置
- 善用客服渠道解决问题`,
    categoryId: "experience",
    categoryName: "体验分享",
    imageSeq: "article-exp-01",
    readCount: 5680,
    publishedAt: "2026-07-10",
    tags: ["用户分享", "使用体验", "真实评价"],
  },
  {
    id: "7",
    slug: "shou-ji-ke-hu-duan-shi-yong-jiao-cheng",
    title: "开云平台手机客户端使用教程",
    summary: "详细讲解开云平台手机客户端的下载、安装和使用方法，让您随时随地享受便捷服务。",
    content: `## 下载安装
开云平台手机客户端支持iOS和Android两大主流系统。

**iOS用户：**
在App Store搜索"开云平台"即可下载安装。

**Android用户：**
访问开云平台官网下载页面，扫描二维码或点击下载链接获取APK安装包。

## 主要功能
手机客户端提供与网页版一致的功能体验：
- 账户管理
- 消息通知
- 在线客服
- 安全设置

## 使用技巧
- 开启推送通知，不错过重要消息
- 设置指纹/面容解锁，快捷又安全
- 使用离线缓存功能，节省流量`,
    categoryId: "platform-guide",
    categoryName: "平台指南",
    imageSeq: "article-mobile-01",
    readCount: 9120,
    publishedAt: "2026-07-25",
    tags: ["手机客户端", "移动端", "使用教程"],
  },
  {
    id: "8",
    slug: "fang-diao-yu-fang-fan-zhi-nan",
    title: "防钓鱼防诈骗安全指南",
    summary: "教您识别钓鱼网站和诈骗信息，保护个人账户和财产安全，远离网络诈骗风险。",
    content: `## 常见诈骗手段
网络诈骗手段层出不穷，以下是几种常见的诈骗方式：
- 假冒客服索要验证码
- 虚假中奖信息诱导点击
- 伪造官方网站骗取密码
- 社交工程诱导转账

## 如何识别钓鱼网站
- 核对网址是否正确
- 查看网站安全证书
- 注意页面细节差异
- 不点击来源不明的链接

## 安全防护建议
- 不向任何人透露验证码
- 不轻信中奖、返利等信息
- 不通过非官方渠道充值
- 遇到可疑情况立即联系官方客服`,
    categoryId: "security",
    categoryName: "安全中心",
    imageSeq: "article-phishing-01",
    readCount: 11240,
    publishedAt: "2026-07-22",
    tags: ["反诈骗", "安全防护", "钓鱼识别"],
  },
];

export function getArticlesByCategory(categoryId: string): Article[] {
  return articles.filter((a) => a.categoryId === categoryId);
}

export function getArticleBySlug(slug: string): Article | undefined {
  return articles.find((a) => a.slug === slug);
}